<mmscan-app-shell
  [logo]="logo()"
  [footerLogo]="footerLogo()"
  [items]="items()"
  [ariaLabel]="'nav.mainNavigation' | translate"
  [sidebarItems]="section()?.items ?? []"
  [sidebarHeading]="section()?.heading"
  collapseBelow="lg"
>
  <div mmscanShellActions class="flex items-center gap-1">
    <mp-notification />
    <mp-header-actions />
  </div>

  <div class="h-full px-2 py-2">
    <router-outlet />
  </div>

  <div mmscanShellFooter class="flex items-center gap-1">
    <span>{{ 'nav.footer.copyright' | translate: { year: currentYear } }}</span>
    <a
      mmscanButton
      variant="ghost"
      severity="secondary"
      size="icon"
      href="https://www.linkedin.com/company/mitsubishi-motor-sales-of-canada-inc-/posts/?feedView=all"
      target="_blank"
      rel="noopener"
      aria-label="LinkedIn"
    >
      <mmscan-icon [icon]="linkedin" size="sm" />
    </a>
    <a
      mmscanButton
      variant="ghost"
      severity="secondary"
      size="icon"
      href="https://www.instagram.com/mitsubishican/"
      target="_blank"
      rel="noopener"
      aria-label="Instagram"
    >
      <mmscan-icon [icon]="instagram" size="sm" />
    </a>
  </div>
</mmscan-app-shell>
